export const fontFamilies = [
  'Aclonica',
  'Aka Posse',
  'Bebas Neue',
  'Chomsky',
  'Grand Hotel',
  'Impact',
  'Indiana',
  'KG Let Her Go',
  'KG Love Is Love Is Love',
  'KG Luck of the Irish',
  'Luckiest Guy',
  'Marker',
  'Pacifico',
  'Pirata One',
  'Ranchers',
  'Righteous',
  'Risque',
  'Sriracha',
  'Victoria Typewriter',
  'Zurich',
  'Holtwood One SC',
  'Laviossa',
  'Redressed',
] as const

export const fontOptions = ['bold', 'italic', 'underline'] as const

export type FontOptionType = typeof fontOptions[number]

export type FontFamilyType = typeof fontFamilies[number]
